<template>
  <div class="html-item-wrap" v-html="showText"></div>
  </template>
  
  <script setup>
  import { computed } from 'vue';
  import useLocate from './uses/useLocate.js';
  import { useRenderConfig } from './uses/useRenderConfig.js';
  import { resolveBindDataKeyValue } from '@/utils/renderBinding';
  // 使用 useLocate 钩子
  const { getLocaleText } = useLocate();
  
  // 定义 props
  const props = defineProps({
    currentElementIndex: {
      type: Array,
      default: () => [],
    },
    idx: {
      type: Number,
      default: -1,
    },
    parentKeys: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
    },
  });

  const { bindData } = useRenderConfig(() => props.config);

  const showText = computed(() => {
    return resolveBindDataKeyValue(
      bindData.value,
      props.config?.bindDataKey,
      props.config?.content || '',
    );
  });
   
  </script>
  
  <style scoped>
  .image-item-wrap {
    display: block;
    width: 100%;
    height: 100%;
  }
  
  .image-item {
    width: 100%;
    height: 100%;
    display: block;
  }
  </style>
  
